module.exports = __webpack_public_path__ + "img/RWBuild Summit Killer Pitch.2389516d.png";